<template>
  <Modal
    data-testid="reminder-modal"
    class="reminder-modal"
    :title="data.title"
    :is-open="data.isOpen"
    @close="emitClose"
  >
    <div>
      <BaseText class="reminder-modal__title">
        Insira abaixo os detalhes para o lembrete de investimento da sua
        carteira.
      </BaseText>
      <InputText
        v-model="investReminderDay"
        mask="##"
        class="reminder-modal__input"
        label="Dia"
        :status="investReminderDayStatus.status"
        :helper-text="investReminderDayStatus.helperText"
        placeholder="1-28"
      />
      <InputMoney
        v-model="monthlyInvestment"
        label="Investimento mensal"
        :helper-text="monthlyInvestmentStatus.helperText"
        :status="monthlyInvestmentStatus.status"
      />
      <ToggleSwitch v-model="investReminder" hide-divider>
        <BaseText>
          <b>{{ toggleTitle }}</b>
        </BaseText>
      </ToggleSwitch>
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Salvar"
            :disabled="!isValid"
            @click="emitSave"
          />
        </template>
        <template #button-secondary>
          <ButtonSecondary label="Cancelar" @click="emitClose" />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>
<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Modal,
  BaseText,
  InputText,
  InputMoney,
  ToggleSwitch,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { IReminderModalProps } from './types';

@Component({
  components: {
    Modal,
    BaseText,
    InputText,
    InputMoney,
    ToggleSwitch,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class InvestReminderModal extends Vue {
  @Prop({ type: Object, required: true })
  readonly data!: IReminderModalProps;

  @Emit('close')
  emitClose() {}

  @Emit('save')
  emitSave() {
    return {
      ...this.data,
      investReminderDay: this.investReminderDay,
      investReminder: this.investReminder,
      monthlyInvestment: this.monthlyInvestment
    };
  }

  @Watch('investReminderDay')
  private handleChangeReminderDay() {
    this.isValidInvestReminderDay();
  }

  @Watch('monthlyInvestment')
  private handleChangeMonthlyInvestment() {
    this.isValidMonthlyInvestment();
  }

  investReminderDay!: string;
  monthlyInvestment!: number;
  investReminder = false;

  investReminderDayStatus = {
    status: 'default',
    helperText: ''
  };

  monthlyInvestmentStatus = {
    status: 'default',
    helperText: ''
  };

  get toggleTitle() {
    return this.investReminder ? 'Habilitado' : 'Desativado';
  }

  get isValid() {
    return this.isValidInvestReminderDay() && this.isValidMonthlyInvestment();
  }

  private isValidInvestReminderDay() {
    const investReminderDay = parseInt(this.investReminderDay);

    if (
      investReminderDay === 0 ||
      investReminderDay > 28 ||
      isNaN(investReminderDay)
    ) {
      this.investReminderDayStatus = {
        status: 'error',
        helperText: 'O dia do lembrete deve ser entre 1 e 28.'
      };
      return false;
    }

    this.investReminderDayStatus = {
      status: 'default',
      helperText: ''
    };
    return true;
  }

  private isValidMonthlyInvestment() {
    if (this.monthlyInvestment === 0 && this.investReminder) {
      this.monthlyInvestmentStatus = {
        status: 'error',
        helperText: 'O valor não pode ser R$0,00.'
      };
      return false;
    }
    this.monthlyInvestmentStatus = {
      status: 'default',
      helperText: ''
    };
    return true;
  }

  created() {
    this.investReminderDay = this.data.investReminderDay;
    this.investReminder = this.data.investReminder;
    this.monthlyInvestment = this.data.monthlyInvestment;
  }
}
</script>
<style lang="less" scoped>
.reminder-modal {
  &__title,
  &__input {
    margin-bottom: @size-spacing-x450;
  }
}
</style>
